export default __webpack_public_path__ + "static/media/24_III.f509b7df.png";